import React from "react";

const Resource = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M17.926 11.48c2.65 0 4.8-2.122 4.8-4.74 0-2.618-2.15-4.74-4.8-4.74-2.651 0-4.8 2.122-4.8 4.74 0 2.618 2.149 4.74 4.8 4.74ZM18 14.177s2.834 0 4.206-.838c1.372-.838 4.48.104 3.657 4.4-.822 4.296-2.834 7.648-7.863 7.963V14.177ZM2 15.039v3.16h2.543s-.53 3.95 3.073 7.562l-1.801 2.031 1.8 1.92 1.802-1.92s3.179 3.386 7.205 3.16V34L18 33.887v-5.982S7.934 27.68 7.192 15.04H2Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M34 15.039v3.16h-2.543s.53 3.95-3.073 7.562l1.801 2.031-1.8 1.92-1.802-1.92s-3.179 3.386-7.205 3.16V34L18 33.887v-5.982s10.066-.225 10.808-12.866H34ZM18 14.177s-2.835 0-4.206-.838c-1.372-.838-4.48.104-3.658 4.4.824 4.296 2.835 7.648 7.864 7.963V14.177Z"
            fill={fill}
        />
    </svg>
);

export default Resource;